import { render, staticRenderFns } from "./DispatcherOrderRequestReviewDetails.vue?vue&type=template&id=1e441224&scoped=true&"
import script from "./DispatcherOrderRequestReviewDetails.vue?vue&type=script&lang=js&"
export * from "./DispatcherOrderRequestReviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherOrderRequestReviewDetails.vue?vue&type=style&index=0&id=1e441224&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e441224",
  null
  
)

export default component.exports